module.exports = __webpack_public_path__ + "static/img/khfw22.14890d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/customer_service/khfw22.jpg
// module id = 99gC
// module chunks = 3